import { Outlet } from 'react-router-dom'

import { ManagementLayout } from '@/app/panel/management/layout'

export const ManagementPage = () => (
  <ManagementLayout>
    <Outlet />
  </ManagementLayout>
)
